<div class="modal-work-schedule" *ngIf="display">
  <div class="modal-container-schedule">
    <div class="modal-header">
      <div class="modal-title">
        <span>Editar escala:</span>&nbsp;
        <span class="captalize" *ngIf="members.length === 1">{{ members[0].userLabel }}</span>
        <span *ngIf="members.length > 1">{{ members.length }} corretores selecionados</span>
      </div>
      <button class="close-modal-btn" (click)="beforeClose()">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="black"/>
        </svg>          
      </button>
    </div>
    <div class="work-schedule-content" *ngIf="form">
      <div class="week-day" *ngFor="let day of form; let dayIdx = index">
        <div class="week-day-label">
          <span>{{ day.label }}</span>
        </div>
        <div class="week-day-schedule">
          <div class="schedule" *ngFor="let schedule of day.schedule; let schIdx = index">
            <div class="schedule__content">
              <app-timepicker id="sch-begin-{{schIdx}}" class="input-box" [ngClass]="{'input-box--error': getError(dayIdx, schIdx).start}" label="Das" [(ngModel)]="schedule.start" (selectValue)="selectStartTime($event, dayIdx, schIdx)"></app-timepicker>
              <app-timepicker id="sch-end-{{schIdx}}" class="input-box" [ngClass]="{'input-box--error': getError(dayIdx, schIdx).end}" label="Até" [(ngModel)]="schedule.end"  (selectValue)="selectEndTime($event, dayIdx, schIdx)"></app-timepicker>
              <div class="action-schedule-btn" (click)="addSchedule(dayIdx)" >
                <svg id="btn-plus-{{schIdx}}" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 6V0H8V6H14V8H8V14H6V8H0V6H6Z" fill="black"/>
                </svg>
              </div>
              <div class="action-schedule-btn" (click)="removeSchedule(dayIdx, schIdx)" *ngIf="day.schedule.length > 1">
                <svg id="btn-plus-2" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="#2A2A2A">
                  <path d="M15 4H20V6H18V19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H3C2.73478 20 2.48043 19.8946 2.29289 19.7071C2.10536 19.5196 2 19.2652 2 19V6H0V4H5V1C5 0.734784 5.10536 0.48043 5.29289 0.292893C5.48043 0.105357 5.73478 0 6 0H14C14.2652 0 14.5196 0.105357 14.7071 0.292893C14.8946 0.48043 15 0.734784 15 1V4ZM16 6H4V18H16V6ZM7 9H9V15H7V9ZM11 9H13V15H11V9ZM7 2V4H13V2H7Z"/>
                </svg>
              </div>
            </div>
            <div class="error__field" *ngIf="(getError(dayIdx, schIdx).start || getError(dayIdx, schIdx).end)">
              <svg id="btn-plus-3" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.0013 11.8346C2.77955 11.8346 0.167969 9.22305 0.167969 6.0013C0.167969 2.77955 2.77955 0.167969 6.0013 0.167969C9.22305 0.167969 11.8346 2.77955 11.8346 6.0013C11.8346 9.22305 9.22305 11.8346 6.0013 11.8346ZM6.0013 10.668C7.23898 10.668 8.42596 10.1763 9.30113 9.30113C10.1763 8.42596 10.668 7.23898 10.668 6.0013C10.668 4.76363 10.1763 3.57664 9.30113 2.70147C8.42596 1.8263 7.23898 1.33464 6.0013 1.33464C4.76363 1.33464 3.57664 1.8263 2.70147 2.70147C1.8263 3.57664 1.33464 4.76363 1.33464 6.0013C1.33464 7.23898 1.8263 8.42596 2.70147 9.30113C3.57664 10.1763 4.76363 10.668 6.0013 10.668ZM5.41797 7.7513H6.58464V8.91797H5.41797V7.7513ZM5.41797 3.08464H6.58464V6.58464H5.41797V3.08464Z" fill="#D6283D"/>
              </svg>
              <span class="error_text">{{getErrorMessage(getError(dayIdx, schIdx).start || getError(dayIdx, schIdx).end)}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <lib-button-tertiary id="work-schedule-cancel-btn" class="footer-btn" (click)="closeModal.emit(); useMock()">Cancelar</lib-button-tertiary>
        <lib-button-primary id="work-schedule-save-btn" class="footer-btn" [ngClass]="{'disable': !dataWasTouched()}" (click)="save()">Salvar</lib-button-primary>
      </div>
      <div class='alert-error-modal' *ngIf='showAlertError'>
        <div class='modal-container-alert-error'>
          <div class='modal-header'>
            <span>Atenção</span>
          </div>
          <div class='modal-content'>
            <div [ngSwitch]="alertType"> 
              <p *ngSwitchCase="'validation'">
                <span *ngIf='showComplementaryMessage'>Não é permitido inserir um horário dentro de um período já existente para o mesmo dia.</span>
                Verifique os campos em vermelho.
              </p>
              <p *ngSwitchCase="'leaveModal'">
                As informações não foram salvas, deseja sair?
              </p>
            </div>
          </div>
          <div class='alert-action'>
            <div [ngSwitch]="alertType">
              <lib-button-primary *ngSwitchCase="'validation'" id="work-alert-save-btn" class="footer-btn" (click)="showAlertError = false">Ok</lib-button-primary>
              <div *ngSwitchCase="'leaveModal'" class='schedule__alert--btn'>
                <lib-button-tertiary id="work-alert-yes-btn" class="footer-btn" (click)="onClose()">Sim</lib-button-tertiary>
                <lib-button-primary id="work-alert-no-btn" class="footer__btn--fill" (click)="showAlertError = false">Não</lib-button-primary>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
